import { useLinkageAmount, useLinkageBusinessAPI } from '../LinkageCreationContext'
import CustomButton from '../../../../../ui/CustomButton'
import { useContext, useEffect, useState } from 'react'
import GlobalContext from '../../../../../../../context/global-context'
import { Title } from '../../../../../ui'
import ResizableModal from '../../../../../ui/ResizableModal'
import { OrganizationAPI } from '../../../../../../../api/organization.api'
import Lottie from 'lottie-react'
import { Box } from '@mui/material'
import LoaderMain from '../../../../../../../assets/svgIcons/loaderMain.json'

const InputField = ({ label, placeholder, type, value, onChange, disabled = false }) => (
  <div>
    <label className='block text-sm font-sans font-medium text-gray-700'>{label}</label>
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`mt-1 block w-full rounded-full border-gray-300 shadow-sm sm:text-sm font-sans
        ${disabled
          ? 'bg-gray-100 text-gray-500 cursor-not-allowed'
          : 'focus:border-indigo-500 focus:ring-indigo-500'}
      `}
    />
  </div>
)

const TextAreaField = ({ label, value, onChange, ...props }) => (
  <div>
    <label className='block text-sm font-sans font-medium text-gray-700'>{label}</label>
    <textarea
      className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm font-sans'
      value={value}
      onChange={onChange}
      maxLength={50}
      required 
      {...props}
    />
    <p className="text-xs text-gray-500 mt-1">
      {value.length}/50 caracteres
    </p>
  </div>
)

const ValoresNegociables = ({ open, setOpen, type = 'egreso', setSwitchDate, idLibro, fVenc, folio,action}) => {
  const [movimientoSeleccionado] = useState(null)
  const [fecha, setFecha] = useState("")
  const [vencimiento, setVencimiento] = useState("")
  const [glosa, setGlosa] = useState("")
  const [tipoContrato, setTipoContrato] = useState("")
  const [monto, setMonto, bankAmountLocked] = useLinkageAmount("")
  const [rut, setRut] = useState("")
  const [razonSocial, setRazonSocial] = useState('')
  const businessAPI = useLinkageBusinessAPI()
  const { currentBusiness } = useContext(GlobalContext)
  const organizationAPI = new OrganizationAPI()
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const [razonesS, setRazonesS] = useState({})

  const handleClose = () => setOpen(false)

  const functionGetData = async () => {
    try {
      setLoading(true)
      const response = await organizationAPI.getDataLibroContable(
        currentBusiness?.id, idLibro, type.trim()
      )
      setData(response.data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const getRazones = async () => {
    try {
      const response = await organizationAPI.getRazonSocial(currentBusiness?.id)
      setRazonesS(response.data)
    } catch (error) {
      console.error(error)
    } finally {
      //
    }
  }

  useEffect(() => {
    if (open && idLibro) {
      functionGetData()
      getRazones()
    }
  }, [open, idLibro])

  useEffect(() => {
    if (data) {
      if (data.fecha) {
        const parsedDate = new Date(data.fecha)
        setFecha(parsedDate.toISOString().split('T')[0])
      }
      if (data.fechaVencimiento) {
        const parsedDate = new Date(data.fechaVencimiento)
        setVencimiento(parsedDate.toISOString().split('T')[0])
      }
      if (data.glosa) setGlosa(data.glosa)
      if (data.montoTotal) setMonto(data.montoTotal.toString())
      if (data.razonSocial) setRazonSocial(data.razonSocial)
      if (data.rut) setRut(data.rut)
      if (data.nombreCodigoDocumento) setTipoContrato(data.nombreCodigoDocumento)
    }
  }, [data])

  const handleDatos = async () => {
    const payload = {
      fecha,
      vencimiento,
      transaccionId: action === "replicar" ? null : movimientoSeleccionado?.id,
      razonSocial,
      rut,
      rutId: null,
      nombreComprobante: tipoContrato || data.nombreCodigoDocumento, // aquí va el string del select
      nombreComprobanteId: null,
      glosa,
      respaldoId: null,
      monto: Number(monto),
    }

    try {
      setLoading(true)
      const response = await businessAPI.postPagoArriendo(
        currentBusiness.id, payload, tipoContrato
      )
      console.info(response)
      setSwitchDate(true)
      handleClose()
    } catch (error) {
      console.error('Error al agregar comprobante:', error.message)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async () => {
    setLoading(true)
    try {
      const payload = {
        fecha,
        vencimiento,
        glosa,
        monto: Number(monto),
        razonSocial,
        rut,
        nombreComprobante: data.nombreCodigoDocumento,
      }

      const razonSeleccionada = razonesS?.find(r => r.rut === rut)
      const promises = []

      if (razonSeleccionada?.code) {
        const idRazonSocial = razonSeleccionada.code.split('-')[0]

        const payloadRazonSocial = { razonSocial } 
        promises.push(
          organizationAPI.patchRazonSocial(
            currentBusiness.id,
            idRazonSocial,
            payloadRazonSocial
          )
        )
      } else {
        //
      }

      promises.push(
        organizationAPI.updateVinculacion(
          currentBusiness?.id,
          idLibro,
          payload
        )
      )

      await Promise.all(promises)
      setSwitchDate(true)
      functionGetData()
      handleClose()

    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const formatMonto = (value) => {
    if (!value) return '' 
    const numericValue = value.replace(/\D/g, '')
    if (!numericValue) return ''
    return new Intl.NumberFormat('es-CL').format(numericValue)
  }
    
  const formatRut = (input) => {
    let cleaned = input.replace(/[^0-9kK]/g, "").toUpperCase()
    // Limita a 9 caracteres (8 cuerpo + 1 DV)
    if (cleaned.length > 9) cleaned = cleaned.slice(0, 9)
    const body = cleaned.slice(0, -1)
    const dv = cleaned.slice(-1)
    let formattedBody = ""
    for (let i = body.length - 1, j = 1; i >= 0; i--, j++) {
      formattedBody = body[i] + formattedBody
      if (j % 3 === 0 && i !== 0) {
        formattedBody = "." + formattedBody
      }
    }
    if (body.length === 0) return dv
    return `${formattedBody}-${dv}`
  }

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0]
    setFecha(today)
    setVencimiento(today)
  }, [])

  const getPlaceholderClasificacion = () => {
    switch (tipoContrato) {
      case "acciones-en-bolsa":
        return "1-1-3-1 Acciones de S.A en Bolsa"
      case "criptomonedas":
        return "1-1-3-2 Criptomonedas"
      case "otros-valores-negociables":
        return "1-1-3-99 Otros valores negociables"
      default:
        return ""
    }
  }

  return (
    <ResizableModal open={open} onClose={handleClose}
      footer={
        <>
          <CustomButton title='CANCELAR' color='primary' className='rounded-full' onClick={handleClose} />
          <CustomButton 
            title={
              action === 'replicar' ? 'REPLICAR VINCULACIÓN' : action === 'modificar'
                ? 'GRABAR VINCULACIÓN' : 'GRABAR VINCULACIÓN'
            }
            color='accent2'
            className='rounded-full'
            onClick={ action === 'modificar' ? handleSubmit : handleDatos }
          />
        </>
      }
    >
    <>
      {loading ?  (
        <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
          <Lottie
            animationData={LoaderMain}
            loop
            autoplay
            style={{ width: 100, height: 100 }}
          />
        </Box>
        ) : (
          <>
          <div className="mt-4">
            <div className='flex justify-between items-center mb-6'>
              <div>
                <Title className='text-3xl font-sans'>Valores Negociables</Title>
              </div>
            </div>
            <div className="flex w-full items-start h-full p-6 bg-white rounded-lg shadow-md">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
                <InputField label="Folio" value={folio} type="text" disabled />
                
                {/* Fecha emisión */}
                <div>
                  <label className="block text-sm font-sans font-medium text-gray-700">Fecha</label>
                  <input
                    type="date"
                    value={fecha}
                    onChange={(e) => setFecha(e.target.value)}
                    className="mt-1 block w-full rounded-full border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm font-sans"
                  />
                </div>

                {/* Fecha vencimiento */}
                <div>
                  <label className="block text-sm font-sans font-medium text-gray-700">Fecha Vencimiento</label>
                  <input
                    type="date"
                    value={vencimiento}
                    onChange={(e) => setVencimiento(e.target.value)}
                    className="mt-1 block w-full rounded-full border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm font-sans"
                  />
                </div>

                {/* Tipo Contrato */}
                <div>
                <label className="block text-sm font-sans font-medium text-gray-700">Tipo Inversión</label>
                <select
                    value={tipoContrato}
                    onChange={(e) => setTipoContrato(e.target.value)}
                    className="mt-1 block w-full rounded-full border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm font-sans"
                >
                    <option value="">Seleccione...</option>
                    <option value="acciones-en-bolsa">Acciones en bolsa</option>
                    <option value="criptomonedas">Criptomonedas</option>
                    <option value="otros-varoles-negociables">Otros Valores Negociales</option>
                </select>
                </div>

                <InputField disabled={bankAmountLocked}
                  label="Monto"
                  placeholder="$"
                  type="text"
                  value={formatMonto(monto)}
                  onChange={(e) => setMonto(e.target.value.replace(/[^0-9]/g, ''))}
                />
                <InputField
                  label="Contraparte"
                  placeholder="Nombre"
                  type="text"
                  value={razonSocial}
                  onChange={(e) => setRazonSocial(e.target.value)}
                />
                <InputField
                  label="RUT"
                  placeholder="11.111.111-1"
                  type="text"
                  value={formatRut(rut)}
                  onChange={(e) => setRut(formatRut(e.target.value))}
                />
                <InputField label="Clasificación" placeholder={getPlaceholderClasificacion()} type="text" disabled />
                <TextAreaField
                  label="Detalle"
                  placeholder="Describe en detalle la naturaleza..."
                  value={glosa}
                  onChange={(e) => setGlosa(e.target.value)}
                />
              </div>
            </div>
          </div>
        </>
      )}
      </>
    </ResizableModal>
  )
}

export default ValoresNegociables